import styled from 'styled-components';
import { getDefaultMobileWidth } from '../../custom-hooks/screen-detector';
import { fadeIn, fadeOut } from '../../transitions';

export const DialogBackDrop = styled.div`
  display: block !important;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0px;
  left: 0px;
  background: ${props =>
    props.noBackDrop === true ? 'transparent' : 'rgba(0, 0, 0, 0.7)'};
  z-index: 9999999999;

  &.fadeIn {
    animation: ${fadeIn} 0.25s;
  }

  &.fadeOut {
    animation: ${fadeOut} 0.25s;
  }
`;

export const DialogContainer = styled.div`
  position: fixed;
  display: flex;
  z-index: 9999999999;
  overflow: hidden;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: auto;
  max-height: 90vh;
  ${props => (props.fullWidth === true ? 'width: 100%' : null)};
  ${props => (props.fullHeight === true ? 'height: 100%' : null)};
  ${props => (props.maxWidth ? `max-width: ${props.maxWidth}` : null)};
  ${props => (props.maxHeight ? `max-height: ${props.maxHeight}` : null)};

  border-radius: ${props => props.borderRadius}px;
  @media (max-width: ${getDefaultMobileWidth()}px) {
    border-radius: ${props => props.mobileBorderRadius}px;
    max-height: ${props => (props.isMobileFullHeight ? '100%' : '90vh')};
  }

  ${props =>
    props.popupType === 'slideout' &&
    `
    top: auto;
    left: auto;
    bottom: 0px !important;
    right: 0px !important;
    transform: translate(0%, 0%);

    border-radius: 0px;
    border-top-left-radius: ${props.borderRadius}px;
    border-top-right-radius: ${props.borderRadius}px;
    @media (max-width: ${getDefaultMobileWidth()}px) {
      border-top-left-radius: ${props.mobileBorderRadius}px;
        border-top-right-radius: ${props.mobileBorderRadius}px;
    }
  `};

  ${props =>
    props.popupType === 'central' &&
    `

    border-radius: 0px;
    border-radius: ${props.borderRadius}px;
    @media (max-width: ${getDefaultMobileWidth()}px) {
      border-radius: ${props.mobileBorderRadius}px;
    }
  `};

  &.mr-transition-in {
    animation: ${props => props.transitionIn} 0.25s;
  }

  &.mr-transition-out {
    animation: ${props => props.transitionOut} 0.25s;
  }
`;

export const DialogInnerContainer = styled.div`
  ${props => (props.fullWidth === true ? 'width: 100%' : null)};
  ${props => (props.fullHeight === true ? 'height: 100%' : null)};
`;
